import { DEBUG } from "../../../../../../../settings/global";
import { processRequirement } from "../helpers";

let sortServers = (data, regionID) => {

    let region = regionID;
    let hasMonthPrice = server => server['prices']['month'];
    let hasHourPrice = server => server['prices']['hour'];
    let receivedFilledLocations = server => Object.keys(server['prices']['locations']).length;
    let hasRegionalMonthPrice = server => (server['prices']['locations'][region] && server['prices']['locations'][region]['price_monthly']) ? server['prices']['locations'][region]['price_monthly'] : null;
    let hasRegionalHourPrice = server => (server['prices']['locations'][region] && server['prices']['locations'][region]['price_hourly']) ? server['prices']['locations'][region]['price_hourly'] : null;
    let hasRamAmount = server => server['ram'];
    let everyServer = hasRequirement => data.every(server => !!hasRequirement(server));
    let monthPrice = weight => parseInt(weight['prices']['month']);
    let hourPrice = weight => parseFloat(weight['prices']['hour']);
    let regionMonthPrice = weight => parseFloat(weight['prices']['locations'][region]['price_monthly']['gross']).toFixed(3);
    let regionHourPrice = weight => parseFloat(weight['prices']['locations'][region]['price_hourly']['gross']).toFixed(3);
    let ramAmount = weight => parseFloat(weight['ram']);
    let sortBy = value => data.sort((a, b) => value(a) - value(b));
    // WARNING - LEGACY CODE !!!
    // function below changes original servers array by replacing regional prices with static
    // Obviously, I understand how shitty it is, but i'm too lazy to refactor it.
    // In my defence - is there any hero dumb enough to dive into all bullshittery happening in this function?
    // Still it helps A LOT to simplify prices render.
    let handleSortingResult = (monthPrice, hourPrice, checkForMonthly, checkForHourly) => {
        let sortedServers = [];
        if (checkForMonthly) sortedServers = sortBy(monthPrice);
        if (checkForHourly) sortedServers = sortBy(hourPrice);
        return sortedServers.map(server => { // simplify prices data
            return {
                ...server,
                prices: {
                    month: checkForMonthly ? monthPrice(server) : null,
                    hour: checkForHourly ? hourPrice(server) : null
                }
            }
        })
    };

    switch (true) {
        case everyServer(hasMonthPrice) || everyServer(hasHourPrice):
            return handleSortingResult(
                monthPrice,
                hourPrice,
                everyServer(hasMonthPrice),
                everyServer(hasHourPrice)
            );
        case (
            region && everyServer(receivedFilledLocations) && everyServer(hasRegionalMonthPrice)
            || region && everyServer(receivedFilledLocations) && everyServer(hasRegionalHourPrice)
        ):
            return handleSortingResult(
                regionMonthPrice,
                regionHourPrice,
                region && everyServer(receivedFilledLocations) && everyServer(hasRegionalMonthPrice),
                region && everyServer(receivedFilledLocations) && everyServer(hasRegionalHourPrice)
            );
        case everyServer(hasRamAmount):
            return sortBy(ramAmount);
        default:
            if (DEBUG) {console.log('%c sortServers : sorting failed (invalid provided data)', 'color:orange')}
            return data;
    }
};

function supportedByRegion(server, regionId) {
    return (
        server.locations && !!server.locations.length
        && server.locations.some(location => location.toString() === regionId.toString())
        || !server.locations || !server.locations.length
    )
}

function lockedByCloud(server) {
    return 'availability' in server && !!server.availability && server.availability !== 'available';
}

function defineIfSupportsRequirements(server, requirements, serverCount) {

    const storage = (server.diskSize || server.resourceDiskSize);
    const reqRam = processRequirement(requirements.ram, serverCount);
    const reqStorage = processRequirement(requirements.storage, serverCount);

    return !!server.ram && server.ram < reqRam || !!storage && storage < reqStorage;
}

export function precessServers(servers, regionId, requirements, serverCount) {

    let processed = [];

    servers.map(server => {
        if (supportedByRegion(server, regionId) && !lockedByCloud(server)) {
            server.isLocked = defineIfSupportsRequirements(server, requirements, serverCount);
            processed.push(server);
        }
    })

    processed = sortServers(processed, regionId);

    return processed
}